import React from "react";
import SasDatePicker from "sassy-datepicker";
import "common/components/DatePicker/styles.css";
export default function DatePicker(props) {
  return <SasDatePicker {...props} />;
}
